import React from "react";
import { Check } from "lucide-react";

interface StepIndicatorProps {
  steps: { label: string }[];
  activeStep: number;
  onStepClick?: (step: number) => void;
}

export function StepIndicator({ steps, activeStep, onStepClick }: StepIndicatorProps) {
  return (
    <div className="flex items-center mb-10">
      {steps.map((step, i) => (
        <React.Fragment key={step.label}>
          {i > 0 && (
            <div
              className={`flex-1 h-px mx-2 sm:mx-4 ${
                i <= activeStep ? "bg-gray-300 dark:bg-slate-600" : "bg-gray-200 dark:bg-slate-700"
              }`}
            />
          )}
          <div
            className={`flex flex-col sm:flex-row items-center gap-1 sm:gap-2 ${onStepClick && i < activeStep ? "cursor-pointer" : ""}`}
            onClick={() => onStepClick && i < activeStep && onStepClick(i)}
          >
            <div
              className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium transition-colors flex-shrink-0 ${
                i < activeStep
                  ? "bg-gray-900 text-white dark:bg-white dark:text-gray-900"
                  : i === activeStep
                    ? "bg-gray-900 text-white dark:bg-white dark:text-gray-900"
                    : "bg-gray-100 text-gray-400 dark:bg-slate-800 dark:text-gray-500"
              }`}
            >
              {i < activeStep ? (
                <Check className="h-3 w-3" />
              ) : (
                i + 1
              )}
            </div>
            <span
              className={`text-[10px] sm:text-xs font-medium ${
                i <= activeStep
                  ? "text-gray-900 dark:text-white"
                  : "text-gray-400 dark:text-gray-500"
              }`}
            >
              {step.label}
            </span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}
